module.exports = __webpack_public_path__ + "images/db565419e84d102092eaf64134aa689f-saveG.svg";